import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, first, map, tap } from 'rxjs/operators';
import { selectCurrentRoom } from '../stores/rooms/rooms.selector';
import { MobileFolioResolverMobileFoliosRequested } from '../sub-features/room/mobilefolio/mobilefolio-store/mobilefolio.actions';

@Injectable({ providedIn: 'root' })
export class MobileFolioResolverService {
  private readonly store = inject(Store);

  resolve(): Observable<boolean> {
    return this.store.select(selectCurrentRoom).pipe(
      filter((room) => !!room),
      tap((room) => {
        if (room?.PmsReferenceCode) {
          this.store.dispatch(new MobileFolioResolverMobileFoliosRequested({ reservationId: room.PmsReferenceCode }));
        }
      }),
      map((room) => !!room?.PmsReferenceCode),
      first()
    );
  }
}
